import Axios from "./axios";

const resource = "jobs";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}